import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ProgrammableLogicController_ModuleContextService } from './ProgrammableLogicController.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_configuration_form_ComponentContextService {
  private readonly moduleContext: ProgrammableLogicController_ModuleContextService;

  constructor(moduleContext: ProgrammableLogicController_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'configuration_form',
      type: ComponentType.form
    }
  }
}